import { buttonTheme } from 'components/Button/theme';

export const actionsTheme = {
  deleteButton: {
    base: {
      ...buttonTheme.icon.base,
      text: 'palette.error.60',
    },
    baseProps: {
      ...buttonTheme.icon.baseProps,
    },
    disabled: {
      ...buttonTheme.icon.disabled,
    },
    focus: {
      ...buttonTheme.icon.focus,
      text: 'palette.error.60',
    },
    hover: {
      ...buttonTheme.icon.hover,
      text: 'palette.error.50',
    },
    pressed: {
      ...buttonTheme.icon.pressed,
      text: 'palette.error.60',
    },
  },
  openActionsButton: {
    active: 'palette.primary.20',
    base: 'palette.tertiary.60',
  },
};
